import axios from "axios";

export type ProfileRecommendationsRoot = {
  cpf: string;
  perfis: Array<{
    perfil: string;
    confianca: number;
    detalhes: {
      autenticado_gov?: boolean;
      aviso?: string;
      cnh_categoria?: string;
      cnh_data_validade?: string;
      possui_veiculos?: boolean;
      quantidade_veiculos?: number;
      motivo?: string;
    };
  }>;
  servicos_recomendados: Array<{
    slug: string;
    motivo: string;
    prioridade: number;
    perfil_origem: string;
    titulo?: string;
    categoria?: string;
    link?: string;
    icone?: string;
    descricao?: string;
  }>;
  servicos_nao_encontrados: Array<string>;
  total: number;
};

const BASE_URL = process.env.RECOMMENDATION_SERVICE_URL || "";

export async function getProfileRecommendationsByUsername(
  preferredUsername?: string
): Promise<ProfileRecommendationsRoot | null> {
  if (!preferredUsername) return null;

  const { data } = await axios.get<ProfileRecommendationsRoot>(
    `${BASE_URL}/v2/recommend_services/${encodeURIComponent(
      preferredUsername
    )}`,
    {
      headers: {
        accept: "application/json",
        "app-key": process.env.APP_KEY || "",
      },
    }
  );

  return data ?? null;
}
